import React from 'react';
import { Form, Row, Input, Col, Button, Select, Typography, DatePicker, Descriptions } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import FormControl from 'components/Forms/FormControl';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import JcsdAccountHandler from '../JcsdAccountHandler';
import ValidationUtility from '../../../Core/ValidationUtility';
import SimpleSelect from '../../Forms/SimpleSelect';
import {
    UserStatus,
    SlimUser,
    Operations,
    Account,
    SlimAccount,
    WebAccountModel,
} from '../../../Core/Api/Api';
import Utility from 'Core/Utility';
import ISelectOption from 'components/Forms/SimpleSelect/ISelectOption';
import {
    singleColFormColSize,
    FullWithButton,
    doubleColFormColSize,
} from '../../Forms/Form.Styled';
import MaskedInput from 'components/Forms/MaskedInput';
import { RightAlignedRow } from 'components/Styled/Layout/RightAlignedRow';
import DetailsMode from 'Core/models/DetailsMode';
import DetailsData from 'Core/models/DetailsData';
import NotificationService from 'Core/NotificationService';
import { LeftAlignedRow } from 'components/Styled/Layout/LeftAlignedRow';
import AuthContext from 'Context/AuthContext';
import moment from 'moment';
import { BorderlessDescriptions } from '../../Offering/OfferingDetailsView';
import { CenterAlignedRow } from '../../Styled/Layout/CenterAlignedRow';

const { Title } = Typography;

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    jurisdictions: ISelectOption[];
    roles: ISelectOption[];
    status: ISelectOption[];
    user?: SlimUser;
    detailsMode: DetailsMode;
    account: any;
}

export class JcsdAccountDetailsFormWithoutFormAndRouter extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    handler: JcsdAccountHandler;

    constructor(props: Props) {
        super(props);

        this.state = {
            jurisdictions: [],
            roles: [],
            status: [],
            detailsMode: DetailsMode.New,
            account: []
        };
        this.handler = new JcsdAccountHandler(props);
    }

    componentDidMount() {
        this.getAccountDetails();
    }

    getAccountDetails() {
        const urlState = this.props.location.state as DetailsData | undefined;

        if (urlState) {


            this.handler.GetAccountById(urlState?.id).then(
                x => {

                    this.setState({ account: x, detailsMode: urlState?.mode ?? DetailsMode.View },
                        () => {
                            this.props.form.setFieldsValue(x ?? {});
                        });
                },
                x => NotificationService.error(x.message)
            );
        } else {
            const id = this.props.match.params as { name: string } | undefined;

            this.handler.GetAccountById(id?.name).then(
                x => {

                    this.setState({ account: x, detailsMode: DetailsMode.View },
                        () => {
                            this.props.form.setFieldsValue(x ?? {});
                        });
                },
                x => NotificationService.error(x.message)
            );
        }
    }

    onSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((error, values: any) => {
            if (error) {
                return;
            }

            if (this.state.detailsMode == DetailsMode.Edit) {
                const request = new WebAccountModel();
                request.accountName = values.accountName;
                request.id = this.state.account?.id;

                this.handler.EditAccount(request).then(x => {
                    NotificationService.success(`Updated sucessfully`, null, 0, true);
                    this.props.history.goBack();
                });
            }


        });
    };

    unlockParent = () => {
        //const request = new EditParentCommandRequest();
        //request.id = this.state.parent?.id;
        //this.handler.UnlockParent(request).then(x => {
        //    NotificationService.success(`Unlocked ${x.parent?.parentFullName}`, null, 0, true);
        //    this.props.history.goBack();
        //});
    }


    setRoles(request: { roles?: string[] }, arg1: any) {
        if (arg1.map) {
            request.roles = arg1;
        } else {
            request.roles = [];
            request.roles.push(arg1);
        }
    }

    render() {
        var { getFieldDecorator } = this.props.form;
        return (
            <>{this.state.detailsMode == DetailsMode.View ?
                <Row type="flex" justify="center">
                    <Col>
                        <Row>
                            <Col span={24}>
                                
                                <Row type="flex">
                                    
                                    <Col>
                                        <Title>Account Details</Title>

                                        <BorderlessDescriptions bordered column={1} >
                                            <Descriptions.Item label="JCSD Number">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.account?.jcsdNumber}
                                                </div>

                                            </Descriptions.Item>

                                            <Descriptions.Item label="Acount Type">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.account?.accountType}
                                                    </div>

                                            </Descriptions.Item>


                                            <Descriptions.Item label="Primary Account Holder">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.account?.primaryAccountHolder}
                                                    </div>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Account Nickname">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.account?.accountName}
                                                    </div>
                                            </Descriptions.Item>
                                            <Descriptions.Item label="Broker">
                                                <div style={{ fontWeight: 'bolder' }}>
                                                    {this.state.account?.brokerName}
                                                    </div>
                                            </Descriptions.Item>
                                        </BorderlessDescriptions>


                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row> :

                <>
                    <Row>
                        <Col>
                            <Form {...singleColFormColSize} layout="horizontal" onSubmit={this.onSubmit}>
                                <Row>
                           
                                    <Col xs={24} sm={22}>
                                        <Col offset={1} span={16}>
                                            <Title>Account Details</Title>

                                            <BorderlessDescriptions column={1} >
                                                <Descriptions.Item label="JCSD Number">
                                                    {this.state.account?.jcsdNumber}

                                                </Descriptions.Item>

                                                <Descriptions.Item label="Acount Type">
                                                    {this.state.account?.accountType}

                                                </Descriptions.Item>


                                                <Descriptions.Item label="Primary Account Holder">

                                                    {this.state.account?.primaryAccountHolder}
                                                </Descriptions.Item>

                                                <Descriptions.Item label="Broker">
                                                    {this.state.account?.brokerName}
                                                </Descriptions.Item>
                                            </BorderlessDescriptions>

                                                    <FormControl
                                                        getFieldDecorator={getFieldDecorator}
                                                rules={[...ValidationUtility.required('Account Nickname is required')]}
                                                        name="accountName"
                                                label="Account Nickname">
                                                        <Input />
                                                    </FormControl>

                                        </Col>

                                       


                                  


                                    </Col>
                                </Row>

                                <LeftAlignedRow>
                                    <Col xs={24} sm={22}>
                                        <Form.Item
                                            colon={false}
                                            label={
                                                <Button onClick={() => this.props.history.goBack()} type="default">
                                                    Back
                    </Button>
                                            }>
                                         
                                                <FullWithButton type="primary" htmlType="submit">
                                                    Submit
                                        </FullWithButton>
                                        </Form.Item>
                                    </Col>
                                </LeftAlignedRow>
                            </Form>
                        </Col >
                    </Row >

                </>
            }
            </>

        );
    }
}

const JcsdAccountDetailsFormWithRouter = Form.create<Props>({
    name: 'UserDetails',
})(JcsdAccountDetailsFormWithoutFormAndRouter);

const JcsdAccountDetailsForm = withRouter(JcsdAccountDetailsFormWithRouter);

export default JcsdAccountDetailsForm;



